<template>
	<div
		class="c-schedule-item"
		:class="{
			'c-schedule-item--inline': inline
		}"
		:style="insetCalendarColorVar(item.calendarThemeColor)"
		@click="handleClickSchedule"
	>
		<div class="c-schedule-item-title text-overflow">{{ checkScheduleThemeName }}</div>
		<div class="c-schedule-item-content">
			<div class="c-schedule-calendar">{{ getCalendarName(item.calendarVO.id) }}</div>
			<div v-if="getScheduleValues.length" class="c-schedule-item-info">
				<div v-for="(value, index) in getScheduleValues" :key="index" class="c-schedule-item-value">
					<span>{{ value }}</span>
				</div>
			</div>
		</div>
		<div v-if="inline" class="c-schedule-item-hr thinner-border-bottom"></div>
	</div>
</template>

<script setup>
import moment from 'moment';
import {
	useScheduleCore,
	checkScheduleHourHide,
	getScheduleThemeName,
	SCHEDULE_CUSTOMS_TYPE
} from '@/hooks/calendar/useScheduleCore';
import { computed } from 'vue';
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';
import { useCalendarCommon } from '@rebuild/materials/shared/customs_calendar/useCalendarCommon';
import i18n from '@/locales';

const { getCalendarName } = useCalendarCommon();
const { insetCalendarColorVar } = useScheduleCore();

const props = defineProps({
	item: {
		type: Object,
		default: () => {
			return {};
		}
	},
	inline: {
		type: Boolean,
		default: false
	},
	formatDate: {
		type: Function,
		default: null
	}
});
const getScheduleDate = computed(() => {
	const { scheduleStartTime, scheduleEndTime } = props.item;
	if (props.formatDate) {
		return props.formatDate(props.item);
	}
	const disVisibleHour = checkScheduleHourHide(props.item);
	if (disVisibleHour) {
		return `${moment(scheduleStartTime).format('YYYY-MM-DD')}`;
	}
	return `${moment(scheduleStartTime).format('HH:mm')} - ${moment(scheduleEndTime).format('HH:mm')}`;
});

const checkScheduleThemeName = computed(() => getScheduleThemeName(props.item));

const getScheduleValues = computed(() => {
	const { customsType, announcementVO } = props.item;
	let renderValues = [];
	const date = getScheduleDate.value;
	if (date) renderValues.push(date);
	if (customsType === SCHEDULE_CUSTOMS_TYPE.ANNOUNCEMENT && announcementVO && !isEn.value) {
		renderValues.push(announcementVO.annoClassif);
	}
	return renderValues;
});

const { viewModule } = useModuleNavigation();
const handleClickSchedule = () => {
	viewModule('customs_calendar', props.item);
};

const isEn = computed(() => i18n.locale == 'en');
</script>

<style lang="less" scoped>
.c-schedule-item {
	padding: 0.14rem 0.12rem;
	background: #fff;
	position: relative;

	&--inline {
		margin-top: 0 !important;
	}

	.c-schedule-item-hr {
		position: absolute !important;
		left: 0.12rem;
		right: 0.12rem;
		bottom: 0;
		height: 1px;
	}
	&:last-child {
		.c-schedule-item-hr {
			display: none;
		}
	}

	& + .c-schedule-item {
		margin-top: 0.14rem;
	}
	.c-schedule-item-margin {
		margin-left: 0.2rem;
	}
	.c-schedule-item-title {
		color: #333;

		font-size: 0.14rem;

		font-weight: 500;
		line-height: 0.2rem;
	}
	.c-schedule-item-content {
		margin-top: 0.04rem;
		display: flex;
		align-items: center;
	}
	.c-schedule-calendar {
		margin-right: 0.08rem;
		padding: 0 0.04rem;
		font-size: 0.1rem;
		line-height: 0.18rem;
		background: var(--calendar-color);
		color: #fff;
	}
	.c-schedule-item-info {
		flex: none;
		display: flex;
		align-items: center;
	}
	.c-schedule-item-value {
		color: #666;

		& + .c-schedule-item-value {
			margin-left: 0.16rem;
			position: relative;

			&::before {
				content: '';
				position: absolute;
				top: 0.02rem;
				left: -0.08rem;
				bottom: 0.02rem;
				width: 1px;
				background: #666;
			}
		}
		span {
			font-size: 0.12rem;

			font-weight: 400;
			line-height: 0.17rem;
		}
	}
}
</style>
